import React from "react";
import {images} from "../../assets/constant"
import SocialMedia from "./SocialMedia";

export default function Header() {
  return (
    <header className="relative min-h-screen flex flex-col items-center justify-center text-center px-4">

      {/* Profile image + name + social */}
      <div className="flex flex-col items-center">
        <div className="w-[115px] h-[115px] rounded-full border-[3.5px] border-accent grid place-items-center">
          <div className="w-[100px] h-[100px] rounded-full overflow-hidden bg-gradient-to-b from-accent to-accent/20 flex items-end justify-center">
            <img src={images.profile2Removebg} alt="Huy Phu" className="w-[75px]" />
          </div>
        </div>
        <h2 className="text-[1.5rem] font-semibold text-title mt-2">Huy Phu</h2>
        <SocialMedia />
        <p className="mt-8 sm:mt-16 text-[0.875rem] text-muted">
          I test what ships, and break what shouldn't.
        </p>
      </div>


{/* Scroll down — pinned to bottom of the hero */}
      <a
        href="#main-content"
        className="absolute bottom-8 inline-flex flex-col items-center gap-1 text-muted hover:text-title transition-colors"
      >
        <span className="font-mono text-[0.7rem] tracking-widest">scroll</span>
        <i className="ri-arrow-down-line text-base animate-bounce"></i>
      </a>

    </header>
  );
}
